module.exports = __webpack_public_path__ + "media/images/front/common/moreLink-8156f2d0913d2e580c49b15dcd127164.png";